import {ImportJob} from './types';

const ACTIVE_JOB_STATUSES: ReadonlySet<ImportJob['status']> = new Set(['QUEUED', 'IN_PROGRESS']);

// The queued publish request almost never names the versions up front - the server discovers them while the job runs -
// so prefer the job's own resolved counts and return null while the count is still unknown.
export function resolveVersionCount(job: ImportJob): number | null {
    const importedVersionCount = job.versionIds?.length ?? 0;
    if (importedVersionCount > 0) {
        return importedVersionCount;
    }

    if (job.totalVersions > 0) {
        return job.totalVersions;
    }

    const requestedVersionCount = job.publishRequest.updateVersionIds?.length ?? 0;
    if (requestedVersionCount > 0) {
        return requestedVersionCount;
    }

    return ACTIVE_JOB_STATUSES.has(job.status) ? null : 0;
}

export function formatVersionCountLabel(job: ImportJob): string {
    const versionCount = resolveVersionCount(job);
    if (versionCount === null) {
        return 'versions pending';
    }

    return `${versionCount} version${versionCount !== 1 ? 's' : ''}`;
}
